<template>
  <div class="about">
    <b-container fluid>

      <div class="table-area">
        <div class="table-responsive-sm">
          <b-table
            selectable
            bordered
            select-mode="single"
            selectedVariant="success"
            :items="audits"
            :fields="auditFields"
            @row-selected="auditRowSelected"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :per-page="perPage"
            :current-page="currentPage"
          >
            <template v-slot:cell(facilityName)='data'>
              <b-link :to="{name:'reviewAudit', params:{auditId:data.item.id}}">{{data.item.facilityName}}</b-link>
            </template>

          </b-table>
          <b-pagination
            v-model="currentPage"
            :total-rows="auditCount"
            :per-page="perPage"
            >
          </b-pagination>
        </div>
      </div>
    </b-container>
  </div>
</template>


<script>
import { Auth } from 'aws-amplify'
import { mapState } from 'vuex'

export default {
    props: [
      "completed"
    ],
    data() {
      return {
        currentPage: 1,
        perPage: 10,
        searchFacility: null,
        searchStatus: "inprogress",
        stateOptions: [
          {value: 'inprogress', text: 'In Progress'},
          {value: 'review-complete', text: 'Review Complete'},
          {value: 'in-review', text: 'In Review'},
          {value: 'complete', text: 'Complete'},
          {value: '*', text: 'All'}
          ],
        'auditFields': [
          {
              key: 'facilityName',
              'label': 'Facility Name',
              sortable: true
          },
          {
              key: 'date',
              'label': 'Date',
              sortable: true
          },
          {
              key: 'state',
              sortable: true,
              formatter: 'prettyStatus',
              label: 'Status'
          }
        ],
        sortBy:'facilityName',
        sortDesc: false
      }
    },
    watch: {
      completed: async function (newVal, oldVal) {
        if(newVal != oldVal) {
          const user = await Auth.currentAuthenticatedUser()

          if(this.completed) {
            this.$store.dispatch('audits/loadCompleted', user.username)
          } else {
            this.$store.dispatch('audits/loadReviews', user.username)
          }
        }
      }
    },
    computed: mapState({
      audits: state => state.audits.all,
      auditCount: state => state.audits.all.length,
      auditSelected: state => state.currentAudit.header
    }),
    methods: {
      auditRowSelected: async function(items) {
        if( items && items.length) {
          const id = items[0].id
          console.log("retrieving", id)
          let audit = this.$store.getters['audits/auditById'](id)
          this.$store.dispatch('currentAudit/setCurrent', audit)
        }
      },
      initAudits: async function() {
        const user = await Auth.currentAuthenticatedUser()

        this.$store.dispatch('audits/loadReviews', user.username)
      },
      prettyStatus(status, key, item) {
        if(status == 'inprogress') return "In Progress"
        else if(status == 'in-review') { 
          console.log("in-review", item)
          if(item.reviewState == 'complete') {
            return 'Review Complete'
          } else {
            return 'In Review'
          }
        }
        else if(status == 'review-complete') return 'Review Complete'
        else if(status == 'complete') return 'Complete'
        else return status
      }
    },
    async created() {
      // TODO: figure out how to share code with init audits above
        console.log("dispatching load audits")
        const user = await Auth.currentAuthenticatedUser()

        if(this.completed) {
          this.$store.dispatch('audits/loadCompleted', user.username)
        } else {
          this.$store.dispatch('audits/loadReviews', user.username)
        }
    }

}
</script>